import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
  className: 'ac-badge',
  base: {
    color: 'grey.dark.1',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '16px',

    display: 'inline-flex',
    height: '22px',
    padding: '3px 10px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,

    backgroundColor: 'grey.light.0',
    borderRadius: 'main',
  },
});
